<template>
  <div>
    <v-container class="indigo lighten-5 my-5">
      <v-card class="white pa-3">
        <h1 class="text-center subtitle-4 black--text">
          <span class="ml-2">جميع الخدمات</span>
        </h1>
        <h2 class="text-center subtitle-4 black--text">
          {{ $route.params.section_name }}
        </h2>
        <v-row class="mt-5">
          <v-col md="3" xs="12">
            <v-btn tile color="primary" @click="addDailog.open = true">
              اضافة خدمة
              <v-icon right style="font-size: 15px">
                fa-plus
              </v-icon>
            </v-btn>
          </v-col>
          <v-spacer></v-spacer>
          <v-col md="4" xs="12">
            <div class="d-flex flex-row">
              <v-text-field v-model="table.search" label="البحث" outlined dense @keyup.enter="search()"></v-text-field>
              <button class="search-btn" @click="search()">
                <v-icon style="font-size: 18px; color: white">
                  fa-search
                </v-icon>
              </button>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="table.headers"
              loading-text="جاري التحميل ... الرجاء الانتظار"
              :items="table.teacherData"
              :options.sync="tableOptions"
              :server-items-length="table.totalTeacherData"
              :loading="table.loading"
              class="elevation-1"
              :footer-props="{
                itemsPerPageOptions: [10, 50, 100],
              }"
            >
              <template slot="item.service_id" slot-scope="props">
                {{ (tableOptions.page - 1) * tableOptions.itemsPerPage + props.index + 1 }}
              </template>
              <template v-slot:item.service_img="{ item }">
                <img
                  v-if="item.service_img"
                  class="teacher_image_table"
                  :src="$store.state.FileUrl + item.service_img"
                  alt
                  width="50"
                  height="50"
                  @click="showImage(item.service_img)"
                />
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="primary" class="ml-2" v-bind="attrs" size="20" v-on="on" @click="edit(item)">
                      fa-edit
                    </v-icon>
                  </template>
                  <span>تعديل</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="#00897B"
                      v-bind="attrs"
                      class="ml-2"
                      size="20"
                      v-on="on"
                      @click="editServiceSection(item)"
                    >
                      fa fa-cog
                    </v-icon>
                  </template>
                  <span>تغيير القسم</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="#FF5252" v-bind="attrs" size="20" v-on="on" @click="deleteItem(item)">
                      fa-trash
                    </v-icon>
                  </template>
                  <span>حذف</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <!-- image Teacher dialog -->
    <v-dialog v-model="table.showImageDailog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">عرض الصورة</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form>
              <v-row class="justify-center">
                <img :src="this.$store.state.FileUrl + table.imageUrlForShow" alt width="300" height="200" />
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="ml-3">
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="table.showImageDailog = false">
            الغاء
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- image Teacher dialog -->

    <!-- addDialog -->
    <v-dialog v-model="addDailog.open" max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">اضافة</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form v-model="addDailog.isFormValid">
              <v-row>
                <!-- service_name -->
                <v-col cols="6">
                  <v-text-field
                    v-model="addData.data.service_name"
                    label="اسم الخدمة"
                    outlined
                    :rules="Rules.name"
                    dense
                    required
                  ></v-text-field>
                </v-col>
                <!-- service_price -->
                <v-col cols="6">
                  <v-text-field
                    v-model="addData.data.service_price"
                    label="السعر"
                    outlined
                    :rules="Rules.price"
                    dense
                    required
                    @keypress="isNumber($event)"
                  ></v-text-field>
                </v-col>
                <!-- service_for_section -->
                <v-col cols="6">
                  <v-autocomplete
                    v-model="addData.data.service_for_section"
                    label="القسم"
                    :items="sections"
                    item-text="section_name"
                    item-value="section_id"
                    outlined
                    dense
                    :loading="editSectionDailog.inputLoading"
                    :rules="Rules.section"
                    required
                  ></v-autocomplete>
                </v-col>

                <!-- service_img -->
                <v-col cols="12">
                  <div class="d-flex justify-space-around align-center">
                    <v-btn text color="primary" @click="$refs.img_addUpload.click()">
                      اضافة الصورة
                    </v-btn>
                    <input v-show="false" id="img_add" ref="img_addUpload" type="file" @change="changeAddImg($event)" />
                    <div class="image-container">
                      <img
                        v-show="addData.IsImgShowing"
                        :src="addData.selectedImg"
                        :lazy-src="addData.imgUrl"
                        alt
                        width="60"
                        height="60"
                      />
                    </div>
                  </div>
                </v-col>

                <!-- service_note -->
                <v-col cols="12">
                  <v-textarea
                    v-model="addData.data.service_note"
                    name="input-7-1"
                    label="النبذة"
                    append-icon="fa-scroll"
                    outlined
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="ml-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="addDailog.open = false">
            الغاء
          </v-btn>
          <v-btn color="primary" :loading="addDailog.loading" :disabled="!addDailog.isFormValid" @click="submitAdd">
            اضافة
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- addDialog -->

    <!-- edit dialog -->
    <v-dialog v-model="editDailog.open" max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">تعديل</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form v-model="editDailog.isFormValid">
              <v-row>
                <!-- service_name -->
                <v-col cols="6">
                  <v-text-field
                    v-model="editedItem.service_name"
                    label="اسم الخدمة"
                    :rules="Rules.name"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </v-col>

                <!-- service_price -->
                <v-col cols="6">
                  <v-text-field
                    v-model="editedItem.service_price"
                    label="السعر"
                    outlined
                    :rules="Rules.price"
                    dense
                    required
                    @keypress="isNumber($event)"
                  ></v-text-field>
                </v-col>

                <!-- Logo -->
                <v-col cols="12">
                  <div class="d-flex justify-space-around align-center">
                    <v-btn text color="primary" @click="$refs.img_editUpload.click()">
                      تعديل الصورة
                    </v-btn>

                    <input
                      v-show="false"
                      id="img_edit"
                      ref="img_editUpload"
                      type="file"
                      @change="changeEditImg($event)"
                    />
                    <div class="image-container">
                      <img
                        v-show="editData.IsImgShowing"
                        :src="editData.imgUrl"
                        :lazy-src="editData.imgUrl"
                        alt
                        width="60"
                        height="60"
                      />
                    </div>
                  </div>
                </v-col>

                <!-- service_note -->
                <v-col cols="12">
                  <v-textarea
                    v-model="editedItem.service_note"
                    name="input-7-1"
                    label="النبذة"
                    append-icon="fa-scroll"
                    outlined
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="ml-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="editDailog.open = false">
            الغاء
          </v-btn>
          <v-btn color="primary" :loading="editDailog.loading" :disabled="!editDailog.isFormValid" @click="submitEdit">
            تعديل
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- edit dialog -->

    <!-- edit service section dialog -->
    <v-dialog v-model="editSectionDailog.open" max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">تعديل القسم</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form v-model="editSectionDailog.isFormValid">
              <v-row>
                <!-- service_section -->
                <v-col cols="12">
                  <v-autocomplete
                    v-model="editedSectionItem.service_for_section"
                    :items="sections"
                    item-text="section_name"
                    item-value="section_id"
                    :rules="Rules.section"
                    outlined
                    dense
                    :loading="editSectionDailog.inputLoading"
                    label="اختيار القسم"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="ml-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="editSectionDailog.open = false">
            الغاء
          </v-btn>
          <v-btn
            color="primary"
            :loading="editSectionDailog.loading"
            :disabled="!editSectionDailog.isFormValid"
            @click="editServiceSectionSubmit"
          >
            تعديل
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- edit service section dialog -->

    <!-- delete dialog -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="headline justify-center">
          هل انت متأكد من حذف هذه الخدمة ؟
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogDelete = false">
            الغاء
          </v-btn>
          <v-btn color="primary white--text" :loading="deleteItemLoading" @click="deleteItemConfirm">
            حذف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End delete dailog -->

    <!--- Dailog for show info to user-->
    <v-dialog v-model="dialogData.open" max-width="500px">
      <v-toolbar :color="dialogData.color" dense></v-toolbar>
      <v-card>
        <v-card-title class="headline justify-center">
          {{ dialogData.bodyText }}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 justify-start" text @click="dialogData.open = false">
            تم
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      editDailog: {
        loading: false,
        isFormValid: false,
        open: false,
      },

      editSectionDailog: {
        loading: false,
        isFormValid: false,
        open: false,
        inputLoading: false,
      },

      addDailog: {
        loading: false,
        isFormValid: false,
        open: false,
      },

      deleteItemLoading: false,

      editedItem: {},

      editedSectionItem: {},

      Rules: {
        name: [value => !!value || 'الاسم مطلوب'],
        price: [value => !!value || 'السعر مطلوب'],
        section: [value => !!value || 'القسم مطلوب'],
      },

      dialogDelete: false,

      dialogData: {
        open: false,
        color: 'primary',
        bodyText: 'test',
      },

      addData: {
        IsImgShowing: false,
        selectedImg: null,
        data: {
          service_name: null,
          service_note: null,
          service_price: null,
          service_for_section: null,
        },
      },

      editData: {
        IsImgShowing: false,
        imgUrl: null,
        selectedImg: null,
      },

      deletedItem: {},

      tableOptions: {},

      sections: [],

      table: {
        search: null,
        totalTeacherData: 0,
        teacherData: [],
        loading: true,
        showImageDailog: false,
        imageUrlForShow: null,

        headers: [
          {
            text: '#',
            align: 'start',
            sortable: false,
            value: 'service_id',
          },
          {
            text: 'الاسم',
            sortable: false,
            value: 'service_name',
          },
          {
            text: 'السعر',
            sortable: false,
            value: 'service_price',
          },
          {
            text: 'القسم',
            sortable: false,
            value: 'section_name',
          },
          { text: 'الصورة', sortable: false, value: 'service_img' },
          {
            text: 'النبذة',
            sortable: false,
            value: 'service_note',
          },
          { text: 'العمليات', value: 'actions', sortable: false },
        ],
      },
    }
  },
  watch: {
    tableOptions: {
      handler () {
        this.getDataAxios()
      },
      deep: true,
    },
    '$route.query.search': {
      handler (search) {
        this.table.search = search
        this.getDataAxios(search)
      },
      deep: true,

      // immediate: true,
    },

    'editData.selectedImg': {
      handler () {
        if (this.editData.imgUrl === null) {
          this.editData.imgUrl = this.$store.state.FileUrl + this.editedItem.service_img
          this.editData.selectedImg = null
        } else {
          this.editData.imgUrl = this.editData.selectedImg
        }
      },
    },
  },

  async mounted () {
    this.getAllSectionsDataAxios()
  },
  methods: {
    getFiles (obj) {
      console.log(obj)
    },

    getDataAxios () {
      let { search } = this.table
      this.table.loading = true
      let { page, itemsPerPage } = this.tableOptions
      if (!search) {
        search = ''
      }

      if (!page) {
        page = 1
      }
      if (!itemsPerPage) {
        itemsPerPage = 10
      }
      this.axios.defaults.headers.common.Authorization = localStorage.getItem('accessToken')
      this.axios
        .post('/allService/getList', {
          section_id: this.$route.params.id,
          page,
          limit: itemsPerPage,
          search,
        })
        .then(Response => {
          if (Response.data.status === 401) {
            this.$store.dispatch('submitLogout')
          } else {
            this.table.loading = false
            this.table.teacherData = Response.data.results
            this.table.totalTeacherData = Response.data.count
          }
        })
        .catch(error => {
          this.table.loading = false
          console.log('error', error)
        })
    },

    getAllSectionsDataAxios () {
      this.editSectionDailog.inputLoading = true

      this.axios.defaults.headers.common.Authorization = localStorage.getItem('accessToken')
      this.axios
        .get('/allSections')
        .then(Response => {
          if (Response.data.status === 401) {
            this.$store.dispatch('submitLogout')
          } else {
            this.editSectionDailog.inputLoading = false
            this.sections = Response.data.results
          }
        })
        .catch(error => {
          this.editSectionDailog.inputLoading = false
          console.log('error', error)
        })
    },

    showImage (image) {
      this.table.showImageDailog = true
      this.table.imageUrlForShow = image
    },

    changeAddImg (event) {
      this.addData.IsImgShowing = true

      const file = event.target.files[0]
      this.addData.selectedImg = null
      if (typeof file !== 'undefined' && file !== null) {
        const fileExt = file.name.split('.').pop()
        if (
          fileExt.toLowerCase() === 'jpg' ||
          fileExt.toLowerCase() === 'jpeg' ||
          fileExt.toLowerCase() === 'png' ||
          fileExt.toLowerCase() === 'png' ||
          fileExt.toLowerCase() === 'gif'
        ) {
          this.addData.selectedImg = URL.createObjectURL(file)
        } else {
          console.log('error_image_add')
        }
      } else {
        this.addData.selectedImg = null
      }
    },

    changeEditImg (event) {
      this.editData.IsImgShowing = true

      const file = event.target.files[0]
      this.editData.selectedImg = null
      if (typeof file !== 'undefined' && file !== null) {
        const fileExt = file.name.split('.').pop()
        if (
          fileExt.toLowerCase() === 'jpg' ||
          fileExt.toLowerCase() === 'jpeg' ||
          fileExt.toLowerCase() === 'png' ||
          fileExt.toLowerCase() === 'png' ||
          fileExt.toLowerCase() === 'gif'
        ) {
          this.editedItem.service_img = null
          this.editData.selectedImg = URL.createObjectURL(file)
        } else {
          console.log('error_image_edit')
        }
      } else {
        this.editData.selectedImg = null
      }
    },

    search () {
      this.$router.replace(
        {
          query: { search: this.table.search },
        },
        () => {},
      )
    },

    deleteItem (item) {
      this.deletedItem = { ...item }
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      this.deleteItemLoading = true
      this.axios.defaults.headers.common.Authorization = localStorage.getItem('accessToken')
      this.axios
        .delete(`allService/${this.deletedItem.service_id}`)
        .then(Response => {
          if (Response.data.error === false) {
            this.deleteItemLoading = false
            this.dialogDelete = false
            this.getDataAxios()
            this.showDialogfunction(Response.data.results, 'primary')
          } else {
            this.showDialogfunction(Response.data.results, '#FF5252')
          }
        })
        .catch(error => {
          this.deleteItemLoading = false
          this.dialogDelete = false
          this.showDialogfunction('حصلت مشكلة يرجى المحاولة مجددا', '#FF5252')
          console.log('error', error)
        })
    },

    submitAdd () {
      this.addDailog.loading = true
      const imageSelected = document.querySelector('#img_add')

      const formData = new FormData()

      if (imageSelected.value === '') {
        this.addDailog.loading = false

        // if there is no logo and no selected logo
        this.editDailog.loading = false
        this.showDialogfunction('يجب اختيار صورة', '#FF8A80')
      } else {
        this.formAppendAdd(formData, imageSelected.files[0])

        this.axios.defaults.headers.common.Authorization = localStorage.getItem('accessToken')

        this.axios
          .post('allService', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(Response => {
            this.addDailog.loading = false
            if (Response.data.error === false) {
              this.addDailog.open = false
              this.addData.data.service_name = null
              this.addData.data.service_price = null
              this.addData.data.service_for_section = null
              this.addData.data.service_note = null
              imageSelected.value = ''
              this.addData.IsImgShowing = false
              this.showDialogfunction(Response.data.results, 'primary')
              this.getDataAxios()
            } else {
              this.showDialogfunction(Response.data.results, '#FF8A80ed')
            }
          })
          .catch(error => {
            this.addDailog.loading = false
            this.showDialogfunction('حدث خطأ يرجى المحاولة مجددا', '#FF8A80')
            console.log('error', error)
          })
      }
    },

    edit (item) {
      this.editedItem = { ...item }
      if (!this.editedItem.service_img) {
        this.editData.IsImgShowing = false
      } else {
        this.editData.IsImgShowing = true
        this.editData.imgUrl = this.$store.state.FileUrl + this.editedItem.service_img
      }
      this.editDailog.open = true
    },

    submitEdit () {
      this.editDailog.loading = true
      const imageSelected = document.querySelector('#img_edit')

      const formData = new FormData()

      if (imageSelected.value === '' && this.editedItem.service_img == null) {
        this.editDailog.loading = false

        // if there is no logo and no selected logo
        this.editDailog.loading = false
        this.showDialogfunction('يجب اختيار صورة', '#FF8A80')
      } else {
        const image = this.editedItem.service_img ? this.editedItem.service_img : imageSelected.files[0]

        this.formAppend(formData, image)

        this.axios.defaults.headers.common.Authorization = localStorage.getItem('accessToken')

        this.axios
          .put('allService', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(Response => {
            this.editDailog.loading = false
            if (Response.data.error === false) {
              this.showDialogfunction(Response.data.results, 'primary')
              this.getDataAxios()
            } else {
              this.showDialogfunction(Response.data.results, '#FF8A80ed')
            }
          })
          .catch(error => {
            this.addBtnLoading = false
            this.showDialogfunction('حدث خطأ يرجى المحاولة مجددا', '#FF8A80')
            console.log('error', error)
          })
      }
    },

    editServiceSection (item) {
      this.editedSectionItem = { ...item }
      this.editSectionDailog.open = true
    },

    editServiceSectionSubmit () {
      this.editSectionDailog.loading = true
      this.axios
        .put('allService/updateServiceSection', {
          service_id: this.editedSectionItem.service_id,
          service_for_section: this.editedSectionItem.service_for_section,
        })
        .then(Response => {
          this.editSectionDailog.loading = false
          if (Response.data.error === false) {
            this.showDialogfunction(Response.data.results, 'primary')
            this.getDataAxios()
          } else {
            this.showDialogfunction(Response.data.results, '#FF8A80ed')
          }
        })
        .catch(error => {
          this.editSectionDailog.loading = false
          this.showDialogfunction('حدث خطأ يرجى المحاولة مجددا', '#FF8A80')
          console.log('error', error)
        })
    },

    showDialogfunction (bodyText, color) {
      this.dialogData.open = true
      this.dialogData.bodyText = bodyText
      this.dialogData.color = color
    },

    formAppend (formData, image) {
      formData.append('service_img', image)
      formData.append('service_name', this.editedItem.service_name)
      formData.append('service_price', this.editedItem.service_price)
      formData.append('service_note', this.editedItem.service_note)
      formData.append('service_for_section', this.$route.params.id)
      formData.append('service_id', this.editedItem.service_id)
    },

    formAppendAdd (formData, image) {
      formData.append('service_img', image)
      formData.append('service_name', this.addData.data.service_name)
      formData.append('service_price', this.addData.data.service_price)
      formData.append('service_for_section', this.addData.data.service_for_section)
      formData.append('service_note', this.addData.data.service_note)
    },

    isNumber (evt) {
      const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.']
      const keyPressed = evt.key
      if (!keysAllowed.includes(keyPressed)) {
        evt.preventDefault()
      }
    },
  },
}
</script>

<style scoped>
.teacher_image_table {
  cursor: pointer;
}
a {
  text-decoration: none;
}
.search-btn {
  width: 49px;
  height: 40px;
  padding: 10px;
  background: #2196f3;
  font-size: 17px;
  border: 1px solid grey;
  border-right: none;
  cursor: pointer;
  line-height: 100%;
  border-radius: 7px;
}
table.v-table tbody td {
  color: black;
}
</style>
